module.exports = __webpack_public_path__ + "img/6-half-sm.5395a83a.jpg";